<template>
  <span id="containerProduto">
    <listaProdutoCard :items="itemsFiltered" name="broker" />
  </span>
</template>

<script>
import { mapMutations, mapGetters, mapState } from "vuex";
import listaProdutoCard from "./listaProdutoCard.vue";
import { getTodosProdutos } from "./produtoUtil";
import store from "../../store/store";
import SecurityService from "@/services/salesforce/SecurityService";
import XippAuthService from "@/services/auth/XippAuthService";

export default {
  methods: {
    ...mapMutations(["showmsg"]),
    ...mapGetters(["mainSearch"]),
    loadItems() {
      this.items.push({
          id: 0,
          titulo: 'Plano de Saúde',
          icon: 'fas fa-heartbeat',
          imgname: 'saude.jpg',
          available: true
        });
    },
    setplano(plano) {
      this.selectedplano = plano;
    },
    solicitarProposta() {
      store.commit("showmsg", {
        text: "Você receberá em breve uma proposta da cotação selecionada.",
        type: "success",
      });
    },
    getvalue (fields, name) {
      if (fields.some((s) => s.key == name)) {
        return fields.find((f) => f.key == name).value.replace("undefined", "");
      } else {
        return "";
      }
    },
    getphone (phone) {
      phone = phone.replace("+55", "");
      phone = phone.replace("(", "");
      phone = phone.replace(")", "");
      phone = phone.replace("-", "");
      return phone.trim();
    },
    async loadJWTToken() {
      if(this.$route.query && this.$route.query.token) {
        const sessionKey = "access_token";
        localStorage.setItem(sessionKey, this.$route.query.token);
        await this._xippAuthService.GetTokenFull()
          .then((response) => {
            if(response && response.data) {
              localStorage.setItem(sessionKey, response.data.token);
            }
          });
      }
    },
  },
  computed: {
    ...mapState(["badges"]),
    itemsFiltered: function () {
      var thiz = this;
      return this.items.filter(function (gsxitem) {
        return thiz.$util
          .removeAccents(gsxitem.titulo)
          .toUpperCase()
          .includes(thiz.$util.removeAccents(thiz.mainSearch()).toUpperCase());
      });
    },
  },
  components: {
    listaProdutoCard,
  },
  beforeCreate() {
    this._xippAuthService = new XippAuthService();
  },
  async created() {
    switch (this.$route.query.t) {
      case "minhas-cotacoes":
        this.selectedTab = "tab-minhas-cotacoes";
        break;
    }

    switch (this.$route.query.origin) {
      case "salesforce":
        this.salesforce = true;
        break;
    }

    this._securityService = new SecurityService();

    if (this.$route.query.token) {
      await this.loadJWTToken();
      
      localStorage.removeItem("current_addfields");
      localStorage.removeItem("current_quote");
      localStorage.removeItem("user_current");

      var origin = this.$route.query.origin;
      //var personType = this.$route.query.personType;
      //var id = this.$route.query.id ? this.$route.query.id : 0; // 0 -  plano de saude

      var ehPj = false;
      var temFields = false;
      var quoteId = "";

      console.log("Vai chamar");
      this._securityService
        .findUserCurrent()
        .then((res) => {
          console.log("RES:"+res.authenticated);
          console.log("RES::Data:"+res.data.authenticated);
          if (
            res.data.authenticated &&
            res.data.principal &&
            res.data.principal.user &&
            res.data.principal.user.additionalFields &&
            res.data.principal.user.additionalFields.length > 0
          ) {
            let fields = res.data.principal.user.additionalFields;
            let cnpj = this.$route.query.cnpj;
            let cpf = this.$route.query.cpf;
            let email = this.$route.query.email;
            let name = this.$route.query.name;
            let phone = this.$route.query.phone;
            let companyName = this.$route.query.legal_name;
            let userId = res.data.principal.user.id;

            quoteId = this.getvalue(fields, "customer.quoteId");
            let accountId = this.getvalue(fields, "customer.accountId");
            let opportunityId = this.getvalue(fields, "modelId");
            let leadId = this.getvalue(fields, "modelId");

            console.log("current_addfields");
            localStorage.setItem(
              "current_addfields",
              JSON.stringify({
                quoteId,
                accountId,
                opportunityId,
                leadId,
                userId,
              })
            );

            let rtDeveloperName = this.getvalue(
              fields,
              "customer.rtDeveloperName"
            );

            temFields = cnpj || cpf || rtDeveloperName;

            if (["business_customer", "business"].includes(rtDeveloperName)) {
              ehPj = true;
              cpf = null;
            } else if (
              ["person_customer", "person"].includes(rtDeveloperName)
            ) {
              ehPj = false;
              cnpj = null;
            } else if (!ehPj) {
              ehPj = cnpj && cnpj.length > 0;
            }

            let phonePrefix = "";
            if (phone && phone.length > 9) {
              phonePrefix = this.getphone(phone).substring(0, 2).trim();
              phone = this.getphone(phone).substring(2).trim();
            }

            //desestruturando usercurrent
            localStorage.setItem(
              "user_current",
              JSON.stringify({
                name,
                companyName,
                cpf,
                cnpj,
                email,
                phone,
                phonePrefix,
                userId,
                quoteId,
                accountId,
                leadId,
                opportunityId,
              })
            );

          } else {
            localStorage.removeItem("user_current");
            localStorage.removeItem("study");
          }
        })
        .catch((reason) => {
          console.log("ERRO: ");
          console.log(reason);
        });
    }
  },
  mounted() {
    this.loadItems();
  },
  data() {
    return {
      model: {
        exibirMinhasCotacoes: false,
      },
      dialog: false,
      chatTooltipTelegram: false,
      items: [],
      configs: [],
      selectedTab: null,
      oportunidades: [],
      selectedplano: null,
      salesforce: false,
    };
  },
};
</script>

<style>
.dados {
  display: flex;
  flex: 1;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
  transition: opacity 0.2s;
}

.dados strong {
  color: var(--v-green-base);
}

.cotacao:hover {
  opacity: 0.8;
  cursor: pointer;
}

.cotacao {
  display: flex;
  align-items: center;
}

.cotacao img {
  width: 60px;
  height: 40px;
  border-radius: 50%;
}

.cotacao h1 {
  font-size: 20px;
  margin-left: 10px;
}
.cotacao h1 span {
  font-size: 12px;
  color: var(--v-foreground-base);
  display: block;
}

#chatTelegramButton,
#cartButton {
  margin-bottom: var(--v-heightBottom) !important;
}

/* badge size */
#containerProduto .v-badge__badge {
  height: 18px !important;
  width: 18px !important;
  min-width: 18px !important;
}
#containerProduto .v-badge__badge span {
  font-size: 12px !important;
}
#containerProduto .v-badge--overlap .v-badge__badge {
  top: -6px !important;
  right: -6px !important;
}

.dataText {
  text-transform: capitalize;
}

.v-expansion-panel:before {
  box-shadow: none !important;
}
</style>
